import { useState, useEffect } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase/config";

const G={bg:"#FAF9F7",s1:"#FFFFFF",s2:"#F4F2EF",border:"#E2DFD9",black:"#1C1917",off:"#3D3830",muted:"#8C8078",orange:"#D2611A",green:"#16A34A",sans:"'Outfit','Helvetica Neue',Arial,sans-serif",mono:"'IBM Plex Mono',monospace"};
const O="#D2611A",BK="#1C1917";
const RUBROS=["Sanitarios","Bañeras","Vanitorys","Pisos SPC","Hornos y Anafes","Puertas","Carpintería","Cocinas","Barandas y Balcones"];

// Rubros con descripción compartida — solo mostrar imagen + nombre + precio
const RUBROS_COMPACTOS=["Pisos SPC","Puertas"];

function generarCatalogoPDF(productos,conPrecios,layout){
  const rubros=RUBROS.filter(r=>productos.some(p=>p.rubro===r));
  const fecha=new Date().toLocaleDateString("es-AR",{year:"numeric",month:"long",day:"numeric"});

  const esCompacto=(rubro)=>RUBROS_COMPACTOS.includes(rubro);

  const css=`
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap');
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Outfit',sans-serif;background:#fff;color:#1C1917;-webkit-print-color-adjust:exact;print-color-adjust:exact}
@page{size:A4;margin:12mm 10mm}
@media print{.np{display:none!important}}
/* Portada */
.portada{page-break-after:always;min-height:257mm;display:flex;flex-direction:column;justify-content:flex-end;padding:24mm 18mm;background:#1C1917}
.ptag{font-size:9px;letter-spacing:3px;text-transform:uppercase;color:#D2611A;margin-bottom:14px;font-weight:600}
.ptitulo{font-size:64px;font-weight:700;color:#fff;line-height:1;margin-bottom:10px}
.psub{font-size:18px;font-weight:300;color:rgba(255,255,255,.4);margin-bottom:44px}
.pbarra{width:56px;height:4px;background:#D2611A;margin-bottom:28px}
.pmeta{display:flex;gap:36px}
.pmeta label{display:block;font-size:7px;letter-spacing:2px;text-transform:uppercase;color:rgba(255,255,255,.25);margin-bottom:3px;font-weight:600}
.pmeta span{font-family:'IBM Plex Mono',monospace;font-size:11px;color:rgba(255,255,255,.55)}
/* Sección */
.sh{page-break-before:always;margin-bottom:18px;padding-bottom:12px;border-bottom:2px solid #E8E4DE}
.sh-tag{font-size:8px;letter-spacing:3px;text-transform:uppercase;color:#D2611A;margin-bottom:4px;font-weight:600}
.sh-t{font-size:26px;font-weight:700;color:#1C1917}
.sh-c{font-family:'IBM Plex Mono',monospace;font-size:9px;color:#8C8078;margin-top:2px}
.sh-medida{display:inline-block;background:#EFF6FF;border:1px solid #2563EB33;padding:3px 10px;font-size:9px;color:#1D4ED8;font-weight:600;margin-top:6px}
/* Grid estándar 2 cols */
.grid2{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:14px}
/* Grid compacto 3-4 cols — para pisos y puertas */
.grid3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin-bottom:10px}
.grid4{display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:8px;margin-bottom:10px}
/* Card estándar */
.card{background:#fff;border:1px solid #E8E4DE;overflow:hidden;page-break-inside:avoid}
.card-img{width:100%;height:150px;object-fit:contain;background:#F4F2EF;display:block;padding:8px}
.card-ph{width:100%;height:150px;background:#F4F2EF;display:flex;align-items:center;justify-content:center;font-size:10px;color:#8C8078}
.cb{padding:10px 12px}
.cb-r{font-size:7px;letter-spacing:2px;text-transform:uppercase;color:#D2611A;margin-bottom:3px;font-weight:600}
.cb-n{font-size:12px;font-weight:700;color:#1C1917;line-height:1.25;margin-bottom:4px}
.cb-sku{font-family:'IBM Plex Mono',monospace;font-size:8px;color:#8C8078;margin-bottom:5px}
.cb-bul{list-style:none}
.cb-bul li{font-size:9px;color:#3D3830;padding:1px 0 1px 10px;position:relative;line-height:1.4}
.cb-bul li::before{content:'→';position:absolute;left:0;color:#D2611A;font-weight:700}
/* Card compacto — solo imagen + nombre */
.card-c{background:#fff;border:1px solid #E8E4DE;overflow:hidden;page-break-inside:avoid}
.card-c-img{width:100%;height:110px;object-fit:contain;background:#F4F2EF;display:block;padding:6px}
.card-c-body{padding:6px 8px}
.card-c-n{font-size:10px;font-weight:700;color:#1C1917;line-height:1.2;margin-bottom:2px}
.card-c-sku{font-family:'IBM Plex Mono',monospace;font-size:7px;color:#8C8078}
/* Precio */
.pbox{background:#FEF3E8;border-top:1px solid #E8E4DE;padding:6px 12px;display:flex;justify-content:space-between;align-items:center}
.pbox-c{background:#FEF3E8;border-top:1px solid #E8E4DE;padding:5px 8px;display:flex;justify-content:space-between;align-items:center}
.p-lbl{font-size:7px;letter-spacing:1.5px;text-transform:uppercase;color:#8C8078;font-weight:600}
.p-val{font-family:'IBM Plex Mono',monospace;font-size:13px;color:#D2611A;font-weight:700}
.p-sin{font-family:'IBM Plex Mono',monospace;font-size:9px;color:#8C8078}
.p-na{background:#F4F2EF;border-top:1px solid #E8E4DE;padding:5px 8px;font-size:9px;color:#8C8078;text-align:center}
/* Footer */
.foot{margin-top:20px;padding-top:10px;border-top:1px solid #E8E4DE;display:flex;justify-content:space-between;font-family:'IBM Plex Mono',monospace;font-size:8px;color:#8C8078}
.btn-p{position:fixed;bottom:20px;right:20px;padding:11px 22px;background:#D2611A;color:#fff;border:none;cursor:pointer;font-family:'Outfit',sans-serif;font-size:10px;letter-spacing:2px;text-transform:uppercase;font-weight:700;border-radius:2px;z-index:100}
`;

  let html=`<!DOCTYPE html><html lang="es"><head><meta charset="utf-8"/><title>Catálogo WINARQ</title><style>${css}</style></head><body>
<div class="portada">
  <div class="ptag">Catálogo de productos · Importación directa China → Argentina</div>
  <div class="ptitulo">WINARQ</div>
  <div class="psub">Materiales de construcción directo de fábrica</div>
  <div class="pbarra"></div>
  <div class="pmeta">
    <div><label>Fecha</label><span>${fecha}</span></div>
    <div><label>Productos</label><span>${productos.length} artículos</span></div>
    <div><label>Categorías</label><span>${rubros.length} rubros</span></div>
    <div><label>Precios</label><span>${conPrecios?"Con IVA incluido":"Consultar"}</span></div>
  </div>
</div>`;

  for(const rubro of rubros){
    const items=productos.filter(p=>p.rubro===rubro);
    const compacto=esCompacto(rubro)||layout==="compacto";
    const esMedida=["Carpintería","Cocinas","Barandas y Balcones"].includes(rubro);
    const cols=compacto?(layout==="4col"?4:3):2;
    const gridClass=cols===4?"grid4":cols===3?"grid3":"grid2";

    html+=`<div class="sh">
  <div class="sh-tag">${rubro}</div>
  <div class="sh-t">${rubro}</div>
  <div class="sh-c">${items.length} producto${items.length!==1?"s":""}</div>
  ${esMedida?`<div class="sh-medida">✦ Fabricación a medida · Trabajo en cooperación con fábrica</div>`:""}
</div>
<div class="${gridClass}">`;

    for(const p of items){
      const buls=(p.descripcion_corta||p.caracteristicas||"").split("\n").map(l=>l.replace(/^[•\-\*]\s*/,"").trim()).filter(Boolean);
      const precio=p.precio_venta;
      const precioIVA=precio?(precio*1.21).toFixed(2):null;

      if(compacto){
        // Card compacto — solo imagen + nombre + precio
        html+=`<div class="card-c">`;
        html+=p.imagen_url?`<img class="card-c-img" src="${p.imagen_url}" alt="${p.nombre}" crossorigin="anonymous"/>`:`<div class="card-c-img" style="display:flex;align-items:center;justify-content:center;font-size:9px;color:#8C8078">Sin imagen</div>`;
        html+=`<div class="card-c-body"><div class="card-c-n">${p.nombre}</div>${p.sku?`<div class="card-c-sku">${p.sku}</div>`:""}</div>`;
        if(conPrecios&&precioIVA)html+=`<div class="pbox-c"><div><div class="p-lbl">c/IVA/${p.unidad||"u"}</div><div class="p-val" style="font-size:11px">USD ${Number(precioIVA).toLocaleString("es-AR",{minimumFractionDigits:2})}</div></div></div>`;
        else html+=`<div class="p-na">${conPrecios?"Cotizar":"Consultá"}</div>`;
        html+=`</div>`;
      } else {
        // Card completo
        html+=`<div class="card">`;
        html+=p.imagen_url?`<img class="card-img" src="${p.imagen_url}" alt="${p.nombre}" crossorigin="anonymous"/>`:`<div class="card-ph">Sin imagen</div>`;
        html+=`<div class="cb"><div class="cb-r">${p.rubro}</div><div class="cb-n">${p.nombre}</div>${p.sku?`<div class="cb-sku">${p.sku}</div>`:""}`;
        if(buls.length>0)html+=`<ul class="cb-bul">${buls.slice(0,4).map(b=>`<li>${b}</li>`).join("")}</ul>`;
        html+=`</div>`;
        if(conPrecios&&precioIVA)html+=`<div class="pbox"><div><div class="p-lbl">Con IVA / ${p.unidad||"u"}</div><div class="p-val">USD ${Number(precioIVA).toLocaleString("es-AR",{minimumFractionDigits:2})}</div></div><div><div class="p-lbl">Sin IVA</div><div class="p-sin">USD ${Number(precio).toLocaleString("es-AR",{minimumFractionDigits:2})}</div></div></div>`;
        else html+=`<div class="p-na">${conPrecios?"Precio a cotizar":"Consultá tu precio"}</div>`;
        html+=`</div>`;
      }
    }
    html+=`</div>`;
  }

  html+=`<div class="foot np"><span>WINARQ · winarq.com.ar · +54 9 11 5061-4489</span><span>Precios orientativos — varían según flete vigente (USD 3.800–9.200 / 40HC)</span></div>
<button class="btn-p np" onclick="window.print()">⬇ Imprimir / Guardar PDF</button>
</body></html>`;
  return html;
}

function generarListaPrecios(productos){
  const rubros=RUBROS.filter(r=>productos.some(p=>p.rubro===r&&p.precio_venta));
  const fecha=new Date().toLocaleDateString("es-AR",{year:"numeric",month:"long",day:"numeric"});
  let html=`<!DOCTYPE html><html lang="es"><head><meta charset="utf-8"/><title>Lista de Precios WINARQ</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap');
*{box-sizing:border-box;margin:0;padding:0}body{font-family:'Outfit',sans-serif;background:#FAF9F7;color:#1C1917;-webkit-print-color-adjust:exact}
@page{size:A4;margin:12mm}@media print{.np{display:none!important}}
.hdr{background:#1C1917;padding:14px 16px;display:flex;justify-content:space-between;align-items:center;margin-bottom:18px}
.hdr-logo{font-size:20px;font-weight:700;color:#fff;letter-spacing:2px}.hdr-logo span{color:#D2611A}
.hdr-r{text-align:right}.hdr-t{font-size:9px;color:rgba(255,255,255,.8);font-weight:600;letter-spacing:2px;text-transform:uppercase}
.hdr-f{font-family:'IBM Plex Mono',monospace;font-size:8px;color:rgba(255,255,255,.35)}
.ley{background:#FEF3E8;border:1px solid #D2611A33;padding:8px 12px;margin-bottom:16px;font-size:9px;color:#3D3830;line-height:1.6}
.sec{margin-bottom:20px;page-break-inside:avoid}.sec-t{background:#D2611A;color:#fff;padding:5px 10px;font-size:8px;letter-spacing:2px;text-transform:uppercase;font-weight:700}
table{width:100%;border-collapse:collapse}
thead th{background:#1C1917;color:#fff;padding:5px 8px;font-size:7px;letter-spacing:1.5px;text-transform:uppercase;font-weight:600;text-align:left}
tbody tr{border-bottom:1px solid #E8E4DE}tbody tr:nth-child(even){background:#F4F2EF}
td{padding:5px 8px;font-size:10px;color:#1C1917}
.tdr{font-family:'IBM Plex Mono',monospace;font-size:11px;color:#D2611A;font-weight:700;text-align:right}
.tds{font-family:'IBM Plex Mono',monospace;font-size:9px;color:#8C8078;text-align:right}
.tdu{font-family:'IBM Plex Mono',monospace;font-size:8px;color:#8C8078;text-align:center}
.tdsku{font-family:'IBM Plex Mono',monospace;font-size:8px;color:#8C8078}
.foot{margin-top:18px;padding-top:8px;border-top:1px solid #E8E4DE;display:flex;justify-content:space-between;font-family:'IBM Plex Mono',monospace;font-size:7px;color:#8C8078}
.btn-p{position:fixed;bottom:20px;right:20px;padding:10px 20px;background:#D2611A;color:#fff;border:none;cursor:pointer;font-family:'Outfit',sans-serif;font-size:9px;letter-spacing:2px;text-transform:uppercase;font-weight:700;border-radius:2px}
</style></head><body>
<div class="hdr"><div class="hdr-logo">WIN<span>ARQ</span></div><div class="hdr-r"><div class="hdr-t">Lista de precios</div><div class="hdr-f">${fecha}</div></div></div>
<div class="ley">⚠ <strong>Precios orientativos con IVA incluido.</strong> Varían según flete vigente del contenedor 40HC (USD 3.800–9.200). Los precios definitivos se confirman al abrir el ciclo. Contacto: <strong>+54 9 11 5061-4489</strong> · <strong>winarq.com.ar</strong></div>`;
  for(const rubro of rubros){
    const items=productos.filter(p=>p.rubro===rubro&&p.precio_venta);
    html+=`<div class="sec"><div class="sec-t">${rubro}</div><table><thead><tr><th>Producto</th><th>SKU</th><th style="text-align:center">Unidad</th><th style="text-align:right">Sin IVA</th><th style="text-align:right">Con IVA</th></tr></thead><tbody>`;
    for(const p of items){
      const p2=(p.precio_venta*1.21).toFixed(2);
      html+=`<tr><td>${p.nombre}</td><td class="tdsku">${p.sku||"—"}</td><td class="tdu">${p.unidad||"u"}</td><td class="tds">USD ${Number(p.precio_venta).toLocaleString("es-AR",{minimumFractionDigits:2})}</td><td class="tdr">USD ${Number(p2).toLocaleString("es-AR",{minimumFractionDigits:2})}</td></tr>`;
    }
    html+=`</tbody></table></div>`;
  }
  html+=`<div class="foot np"><span>WINARQ · winarq.com.ar</span><span>Precios en USD · IVA 21% incluido · Sujetos a variación del flete</span></div>
<button class="btn-p np" onclick="window.print()">⬇ Imprimir / Guardar PDF</button></body></html>`;
  return html;
}

export default function AdminCatalogo(){
  const[productos,setProductos]=useState([]);
  const[loading,setLoading]=useState(true);
  const[conPrecios,setConPrecios]=useState(false);
  const[soloRubro,setSoloRubro]=useState("Todos");
  const[layout,setLayout]=useState("auto"); // auto | compacto | 4col

  useEffect(()=>{
    getDocs(query(collection(db,"productos"),where("publicado","==",true)))
      .then(snap=>{setProductos(snap.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(a.orden||999)-(b.orden||999)));setLoading(false);})
      .catch(()=>setLoading(false));
  },[]);

  const filtrados=soloRubro==="Todos"?productos:productos.filter(p=>p.rubro===soloRubro);
  const rubros=RUBROS.filter(r=>productos.some(p=>p.rubro===r));
  const abrir=html=>{const w=window.open("","_blank");w.document.write(html);w.document.close();};
  const sel={width:"100%",background:"#FFFFFF",color:BK,border:`1px solid ${G.border}`,fontFamily:G.sans,fontSize:13,padding:"7px 10px",outline:"none"};
  const btn=bg=>({padding:"11px 20px",background:bg,color:"#fff",fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",border:"none",cursor:"pointer",fontWeight:700});

  return(
    <div>
      <div style={{fontFamily:G.sans,fontSize:22,color:G.black,fontWeight:700,marginBottom:4}}>Catálogo y lista de precios</div>
      <div style={{fontFamily:G.sans,fontSize:11,color:G.muted,marginBottom:24}}>{productos.length} productos publicados</div>
      {loading?<div style={{padding:40,textAlign:"center",fontFamily:G.sans,fontSize:12,color:G.muted}}>Cargando...</div>:(
        <>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24,marginBottom:24}}>
            {/* Catálogo */}
            <div style={{background:G.s1,border:`1.5px solid ${G.border}`,padding:"22px 26px"}}>
              <div style={{fontFamily:G.sans,fontSize:16,color:G.black,fontWeight:700,marginBottom:4}}>Catálogo de productos</div>
              <div style={{fontFamily:G.sans,fontSize:11,color:G.muted,marginBottom:18,lineHeight:1.6}}>Portada WINARQ · A4 · Por categorías · Imágenes completas</div>

              <div style={{marginBottom:12}}>
                <div style={{fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",color:G.muted,marginBottom:5,fontWeight:600}}>Categoría</div>
                <select value={soloRubro} onChange={e=>setSoloRubro(e.target.value)} style={sel}><option>Todos</option>{rubros.map(r=><option key={r}>{r}</option>)}</select>
              </div>

              <div style={{marginBottom:12}}>
                <div style={{fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",color:G.muted,marginBottom:5,fontWeight:600}}>Layout</div>
                <div style={{display:"flex",gap:6}}>
                  {[["auto","Automático (recomendado)"],["compacto","Compacto 3 col."],["4col","Muy compacto 4 col."]].map(([v,l])=>(
                    <button key={v} onClick={()=>setLayout(v)} style={{flex:1,padding:"6px 8px",fontFamily:G.sans,fontSize:9,background:layout===v?BK:"transparent",color:layout===v?"#fff":G.muted,border:`1.5px solid ${layout===v?BK:G.border}`,cursor:"pointer",fontWeight:layout===v?700:500}}>
                      {l}
                    </button>
                  ))}
                </div>
                <div style={{fontFamily:G.sans,fontSize:10,color:G.muted,marginTop:6,lineHeight:1.5}}>
                  Automático: Pisos y Puertas en 3 col. (solo foto+nombre), resto en 2 col. con descripción.
                </div>
              </div>

              <label style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",marginBottom:18}}>
                <input type="checkbox" checked={conPrecios} onChange={e=>setConPrecios(e.target.checked)}/>
                <span style={{fontFamily:G.sans,fontSize:12,color:G.off}}>Incluir precios con IVA</span>
              </label>

              <div style={{background:G.s2,padding:"8px 12px",marginBottom:18,border:`1px solid ${G.border}`,fontFamily:G.mono,fontSize:10,color:G.muted}}>
                {filtrados.length} productos · {soloRubro==="Todos"?`${rubros.length} categorías`:soloRubro}
              </div>
              <button onClick={()=>abrir(generarCatalogoPDF(filtrados,conPrecios,layout))} style={btn(BK)}>⬇ Generar catálogo PDF</button>
            </div>

            {/* Lista de precios */}
            <div style={{background:G.s1,border:`1.5px solid ${G.border}`,padding:"22px 26px"}}>
              <div style={{fontFamily:G.sans,fontSize:16,color:G.black,fontWeight:700,marginBottom:4}}>Lista de precios</div>
              <div style={{fontFamily:G.sans,fontSize:11,color:G.muted,marginBottom:18,lineHeight:1.6}}>Tabla A4 · Por categorías · Sin y con IVA · Leyenda de variabilidad del flete</div>
              <div style={{marginBottom:12}}>
                <div style={{fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",color:G.muted,marginBottom:5,fontWeight:600}}>Categoría</div>
                <select value={soloRubro} onChange={e=>setSoloRubro(e.target.value)} style={sel}><option>Todos</option>{rubros.map(r=><option key={r}>{r}</option>)}</select>
              </div>
              <div style={{background:"#FEF3E8",border:`1px solid ${O}33`,padding:"10px 12px",marginBottom:18,fontFamily:G.sans,fontSize:11,color:G.off,lineHeight:1.5}}>
                {filtrados.filter(p=>p.precio_venta).length} de {filtrados.length} productos tienen precio cargado.
              </div>
              <button onClick={()=>abrir(generarListaPrecios(filtrados))} style={btn(O)}>⬇ Generar lista de precios</button>
            </div>
          </div>

          {/* Resumen */}
          <div style={{background:G.s2,border:`1px solid ${G.border}`,padding:"14px 18px"}}>
            <div style={{fontFamily:G.sans,fontSize:9,letterSpacing:2,textTransform:"uppercase",color:G.muted,marginBottom:10,fontWeight:600}}>Resumen por categoría</div>
            <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
              {rubros.map(r=>(
                <div key={r} style={{background:G.s1,border:`1px solid ${G.border}`,padding:"8px 14px"}}>
                  <div style={{fontFamily:G.sans,fontSize:11,color:G.black,fontWeight:600}}>{r}</div>
                  <div style={{fontFamily:G.mono,fontSize:10,color:O}}>{productos.filter(p=>p.rubro===r).length} prod · {productos.filter(p=>p.rubro===r&&p.precio_venta).length} c/precio</div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
